import React, { lazy, Suspense } from "react";
import Loader from "../layouts/Loader";
import { Route } from "react-router-dom";
import Notifications from "../layouts/notifications/Notifications";

function Public(props) {
  const { component, ...rest } = props;
  const Component = lazy(() => import(`../${component}`));
  return (
    <Route
      {...rest}
      render={(props) => (
        <Suspense fallback={<Loader />}>
          <Notifications />
          <Component {...props} />
        </Suspense>
      )}
    />
  );
}

export default Public;
